module.exports = {"320111001":"泰山街道","320111002":"顶山街道","320111003":"沿江街道","320111004":"江浦街道","320111005":"桥林街道","320111006":"汤泉街道","320111007":"盘城街道","320111008":"星甸街道","320111009":"永宁街道","320111400":"老山林场","320111401":"汤泉农场","320111402":"珍珠泉旅游度假区","320111403":"浦口经济开发区","320111404":"南京浦口高新技术产业开发区","320111450":"高新技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320111.json
// module id = 929
// module chunks = 0